<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details" *ngIf="isEdit">
                <h4 class="personal-details-title">Edit Product Display Zone</h4>
                <div cdkDropListGroup class="composition-block">
                  <div class="example-container-left">
                    <h2>Products</h2>
                
                    <div
                      cdkDropList
                      [cdkDropListData]="cProductList"
                      class="example-list1"
                      (cdkDropListDropped)="drop($event)">
                      <div class="example-box1" *ngFor="let item of cProductList" cdkDrag>{{item.name}}</div>
                    </div>
                  </div>
                
                  <div class="example-container-right">
                    <h2>Zone Name</h2>
                    <div class="row">
                      <div class="col-md-8 col-lg-8">
                        <input type="text" placeholder="enter zone name" [(ngModel)]="zoneName" class="form-control">
                      </div>
                      <div class="col-md-4 col-lg-4">
                        <input type="text" placeholder="no of products per line" class="form-control" [(ngModel)]="noOfProductsPerLine">
                      </div>
                    </div>
               
  
                    <div
                      cdkDropList
                      [cdkDropListData]="done"
                      class="example-list"
                      (cdkDropListDropped)="drop($event)">
                      <div class="example-box" *ngFor="let item of done" cdkDrag>
                        <div class="row input-data">
                          <!-- <div class="col-md-12 col-lg-12">
                            <p>{{item.name}}</p>
                          </div> -->
                          <div class="col-md-6 col-lg-6">
                            <label for="">Name:</label>
                            <p>{{item.name}}</p>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <label for="">Group:</label>
                            <p>{{item.group}}</p>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <label for="">Code:</label>
                            <p>{{item.code}}</p>
                          </div>
                          <div class="col-md-6 col-lg-6">
                            <label for="">Description:</label>
                            <p>{{item.description}}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="submit-footer">
                      <div>
                        <button class="btn btn-secondary" (click)="closeEdit()">Cancel</button>
                        <button class="add-b" (click)="editProductDisplayZone()">submit</button>
                      </div>
                    </div>
                  </div>
              </div>
            </div>
  
            <div class="personal-details" *ngIf="!isEdit">
                <h4 class="personal-details-title">Product Display Zone List</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">Zone Name</th>
                      <th scope="col">No. of Products</th>
                      <th scope="col">No. of products per-line</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let product of productDisplayZoneList | paginate : {
                      itemsPerPage: tableSize,
                      currentPage: page,
                      totalItems: count};let i = index">
                      <th scope="col">{{product.zoneName}}</th>
                      <th scope="col">{{product.productInfoObjList.length}}</th>
                      <th scope="col">{{product.noOfProductsPerLine}}</th>
                      <th>
                        <i class="bi bi-pencil-square" (click)="getProductDisplayZoneById(product.displayZoneId)" data-toggle="modal" data-target="#exampleModalView" ></i>
                      </th>
                    </tr>
                  </tbody>
                </table>
                <div class="pagination-block" *ngIf="productDisplayZoneList.length != 0">
                  <pagination-controls
                    previousLabel="Prev"
                    nextLabel="Next"
                    (pageChange)="onTableDataChange($event)"
                  >
                  </pagination-controls>
                </div>
            </div>
        </div>
    </div>
  </div>